export const READONLY_GRACE_DAYS = 7

export type DepartureStatus = 'ACTIVE' | 'NOTICE_PERIOD' | 'READONLY' | 'LOCKED'

export interface DepartureInfo {
  status: DepartureStatus
  departureDate: Date | null
  daysUntilDeparture: number | null
  daysUntilLock: number | null
}

export function getDepartureInfo(departureDate: string | Date | null | undefined): DepartureInfo {
  if (!departureDate) {
    return { status: 'ACTIVE', departureDate: null, daysUntilDeparture: null, daysUntilLock: null }
  }

  const dep = typeof departureDate === 'string' ? new Date(departureDate) : departureDate
  const today = startOfDay(new Date())
  const depDay = startOfDay(dep)
  const lockDay = new Date(depDay)
  lockDay.setDate(lockDay.getDate() + READONLY_GRACE_DAYS)

  const msPerDay = 24 * 60 * 60 * 1000
  const daysUntilDeparture = Math.round((depDay.getTime() - today.getTime()) / msPerDay)
  const daysUntilLock = Math.round((lockDay.getTime() - today.getTime()) / msPerDay)

  let status: DepartureStatus
  if (today < depDay) status = 'NOTICE_PERIOD'
  else if (today < lockDay) status = 'READONLY'
  else status = 'LOCKED'

  return { status, departureDate: depDay, daysUntilDeparture, daysUntilLock }
}

export function isDepartureReadOnly(departureDate: string | Date | null | undefined): boolean {
  const status = getDepartureInfo(departureDate).status
  return status === 'READONLY' || status === 'LOCKED'
}

function startOfDay(d: Date): Date {
  const x = new Date(d)
  x.setHours(0, 0, 0, 0)
  return x
}
